import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "main",
  class: "about"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "このサイトについて", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("ポストエクスプレス"),
  /*#__PURE__*/_createElementVNode("span", null, "®"),
  /*#__PURE__*/_createTextVNode("WEB（栃木県北版）は、"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.ikeposu.com/",
    target: "_blank"
  }, "有限会社 池田新聞店"),
  /*#__PURE__*/_createTextVNode("が運営しています。")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://pe.alliance-web.jp" }, "pe.alliance-web.jp")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, "Version " + _toDisplayString(_ctx.version), 1),
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          round: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("栃木県北版TOPに戻る")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_4
  ]))
}